import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { illustrationFor } from "../../lib/data";

export const Eyebrow = ({ children, className = "" }) => (
  <div className={`eyebrow ${className}`}>{children}</div>
);

export const GoldRule = ({ className = "" }) => <div className={`gold-rule ${className}`} />;

export const SectionTitle = ({ eyebrow, title, intro, center = false }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-maroon">{title}</h2>
    {!center && <div className="gold-rule mt-6" />}
    {intro && <p className="mt-6 text-base lg:text-lg leading-relaxed text-ink-muted">{intro}</p>}
  </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);

export const EmptyState = ({ title, message, icon: Icon }) => (
  <div className="border border-gold/25 bg-white px-8 py-16 text-center" data-testid="empty-state">
    {Icon && <Icon className="mx-auto mb-5 text-gold" size={34} strokeWidth={1.2} />}
    <h3 className="text-2xl font-medium text-maroon">{title}</h3>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-ink-muted">{message}</p>
  </div>
);

export const FocusCard = ({ item, highlight = false, index = 0 }) => {
  const to = /old age/i.test(item.title || "") ? "/elder-care" : null;
  const inner = (
    <div
      data-testid={`focus-card-${index}`}
      className={`group h-full border bg-white transition-colors duration-500 ${
        highlight ? "border-gold/60 md:col-span-2" : "border-gold/20 hover:border-gold/60"
      }`}
    >
      <div className={`overflow-hidden bg-ivory ${highlight ? "aspect-[2/1]" : "aspect-square"}`}>
        <img
          src={illustrationFor(item.illustration)}
          alt={item.title}
          loading="lazy"
          className="h-full w-full object-contain p-6 transition-transform duration-700 group-hover:scale-[1.03]"
        />
      </div>
      <div className="border-t border-gold/20 p-7">
        {highlight && <Eyebrow className="mb-3">Primary Focus</Eyebrow>}
        <h3 className="text-xl font-medium text-maroon">{item.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-ink-muted">{item.description}</p>
        {to && <span className="mt-4 inline-block text-xs font-semibold uppercase tracking-wide text-gold-dark">Learn more →</span>}
      </div>
    </div>
  );
  return (
    <Reveal delay={index * 0.05} className={highlight ? "md:col-span-2" : ""}>
      {to ? <Link to={to} data-testid="focus-eldercare-link">{inner}</Link> : inner}
    </Reveal>
  );
};
